(function() { module.exports = window["wp"]["date"]; }());